import { Building } from "lucide-react";

import { cn } from "@/lib/utils";
import { MARKER_COLOR } from "components/CaseMap/mapLayers";

/**
 * The case's own location. Same pin shape as a machine so the two read as
 * markers of equal weight — the icon and hue are what tell them apart.
 */
export function AddressMarkerPin({ selected }) {
  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:drop-shadow-md">
      <div
        className={cn(
          "tw:flex tw:size-8 tw:items-center tw:justify-center tw:rounded-full tw:text-white tw:ring-2 tw:ring-white tw:transition-transform tw:hover:scale-110",
          selected && "tw:scale-110 tw:ring-3"
        )}
        style={{ backgroundColor: MARKER_COLOR.address }}
      >
        <Building className="tw:size-4" />
      </div>
      <div
        className="tw:-mt-px tw:size-0 tw:border-x-[5px] tw:border-t-[7px] tw:border-x-transparent"
        style={{ borderTopColor: MARKER_COLOR.address }}
      />
    </div>
  );
}
